var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmailFront(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 127,
    viewBox: "0 0 117 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.5 108L112 54.5L58.5 1L5 54.5L58.5 108Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 61.0644L58.5 114.564L112 61.0644V54.5L58.5 108L5 54.5V61.0644Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 54.5V61.0644L58.5 114.564L112 61.0644V54.5M5 54.5L58.5 108L112 54.5M5 54.5L58.5 1L112 54.5",
    stroke: "#12D253"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5 114.564C79.393 93.6714 112 61.0644 112 61.0644V54.5517L58.5 108V111.282C58.5 111.282 58.5 113.283 58.5 114.564Z",
    fill: "#12D253"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5 108L5 54.5V61.0644C25.893 81.9575 37.607 93.6714 58.5 114.564C58.5 113.283 58.5 111.282 58.5 111.282V108Z",
    fill: "#0B8133"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2913 38.1667H80.7063L58.5 56.1637L36.2913 38.1667Z",
    fill: "#12D253"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9537 52.001L35.1667 65.329V43.2603L45.9537 52.001Z",
    fill: "#12D253"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5773 54.9387L58.5 62.1697L67.4367 54.927L80.5313 70.8333H36.7137L49.5773 54.9387Z",
    fill: "#12D253"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0627 51.9893L81.8333 43.2603V65.0723L71.0627 51.9893Z",
    fill: "#12D253"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailFront);
export default __webpack_public_path__ + "static/media/email-front.77e1c7b547188b58a94d16bc2bcca624.svg";
export { ForwardRef as ReactComponent };